import { urls } from './urls';

const config = {
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    urls,
};

export default config;
